import { MOTOR, SZGK, TEHER } from '../modules/Gepjarmu';

/**
 * Különböző gépjármű adatmodellek közötti konverziókat végez
 */
export default class VehicleConverter {
    /**
     *
     * @param {object} car Gépjármű adatok extax api modell alapján
     * @returns {{
     * gyartmany: *,
     * hengerurtartalom: number,
     * szallszem: number, fajta: *,
     * sajattomeg: number,
     * teljesitmeny_kw: number,
     * ossztomeg: number,
     * tipus: *,
     * kivitel: *,
     * ajtok_szama: number
     * }}
     */
    static etaxToGpjTorzs(car) {
        const gepjarmuFajta = { 10: SZGK, 20: TEHER, 30: MOTOR }[+car.gepjarmu_tipus] || SZGK;
        return {
            fajta: gepjarmuFajta,
            gyartmany: car.ajanl_gyartmany,
            tipus: gepjarmuFajta === MOTOR ? car.tipusnev : car.modell_generacio,
            hengerurtartalom: parseInt(car.hengerurtartalom, 10) || null,
            teljesitmeny_kw: parseInt(car.teljesitmeny_kw, 10) || null,
            teljesitmeny_kw_2: parseInt(car.teljesitmeny_kw_2, 10) || null,
            sajattomeg: parseInt(car.sajat_tomeg, 10) || null,
            ossztomeg: parseInt(car.ossztomeg, 10) || null,
            szallszem: parseInt(car.ferohelyek_szama, 10) || null,
            ajtok_szama: parseInt(car.ajtok_szama, 10) || null,
            kivitel: car.kivitel_kod,
            jobbkormanyos: car.kormany_jobboldalon === 'Y',
            uzemanyag: parseInt(car.uzemanyag_kod, 10) || null,
            eurotaxcode: car.eurotax,
        };
    }

    /**
     * @param oldObj Extrakat tartalmazo objektum a regi elnevezes szerint
     * @returns {{
     * led_fenyszorok: boolean,
     * adaptiv: boolean,
     * kulonleges_keres: boolean,
     * klima: boolean,
     * extra_fenyezes: boolean,
     * video: boolean,
     * gallytoro: boolean,
     * xenon_fenyorok: boolean,
     * vezetestamogatas: boolean,
     * tetoablak: boolean,
     * hifi: boolean,
     * fixuvegtato: boolean,
     * navigacio: boolean,
     * ultrahangos_parkolasiranyitas: boolean,
     * mozgathato_tetoboritas: boolean,
     * borkarpit: boolean,
     * nyithatouvegteto: boolean,
     * vonohorog: boolean,
     * automatasebvalto: boolean
     * }}
     */
    static convertOldExtrasObj(oldObj) {
        return {
            klima: oldObj.extra_legkondicionalo,
            kulonleges_keres: oldObj.extra_kulkerek,
            automatasebvalto: oldObj.extra_automatasebvalto,
            led_fenyszorok: oldObj.extra_led,
            xenon_fenyorok: oldObj.extra_xenon,
            navigacio: oldObj.extra_navigacio,
            borkarpit: oldObj.extra_bor,
            extra_fenyezes: oldObj.extra_fenyezes,
            ultrahangos_parkolasiranyitas: oldObj.extra_ultrahangos,
            hifi: oldObj.extra_hifi,
            video: oldObj.extra_video,
            vezetestamogatas: oldObj.extra_vezetestamogatas,
            fixuvegtato: oldObj.extra_fixuvegteto,
            nyithatouvegteto: oldObj.extra_nyithatouvegteto,
            tetoablak: oldObj.extra_tetoablak,
            mozgathato_tetoboritas: oldObj.extra_mozgathato_tetoboritas,
            adaptiv: oldObj.extra_adaptiv,
            gallytoro: oldObj.extra_gallytoro,
            vonohorog: oldObj.extra_vonohorog,
        };
    }
}
